import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc4116e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "merge-customer-dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "顧客を統合する", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, " ※選択した顧客を統合する場合、最新の顧客情報は統合された顧客に上書きされます（情報が空の場合は、上書きされずに保持されます）。 ", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mt-3" }

import { ICustomer } from "@/clinic/typings";
import { withDefaults, ref, watch, computed } from "vue";
import { PreviewMergedCustomerFieldNames } from "@/clinic/typings/enums/customer";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import DuplicateCustomerService from "@/clinic/services/duplicate-customer.services";
import Preview from "@/clinic/views/DuplicateCustomer/Dialog/components/preview.vue";
import CustomerTable from "@/clinic/views/DuplicateCustomer/Dialog/components/customer-table.vue";

type IProps = {
  clinicId: any;
  visible: boolean;
  primaryCustomer: any;
  duplicateCustomers: any[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'merge',
  props: {
    clinicId: null,
    visible: { type: Boolean, default: false },
    primaryCustomer: null,
    duplicateCustomers: null
  },
  emits: ["toggle"],
  setup(__props: any, { emit: emits }) {

const props = __props as { clinicId: any, visible: boolean, primaryCustomer: any, duplicateCustomers: any[] };

const confirm = useConfirm();
const toast = useToast();

const actions = {
  list: "list",
  preview: "preview",
  merge: "merge",
};




const filteredMergedCustomers = ref<ICustomer[]>([]);
const selectedMergedCustomers = ref<ICustomer[]>([]);
const selectedPrimaryCustomer = ref(props.primaryCustomer);
const previewData = ref<any[]>([]);
const step = ref(actions.list);
const previousStep = ref();
const previewLoading = ref(false);

const validToMerge = computed(() => selectedPrimaryCustomer.value && selectedMergedCustomers.value.length > 0);

const onTableDataChange = (data: any, selectMultiple: boolean) => {
  if (selectMultiple) {
    selectedMergedCustomers.value = data;
  } else {
    selectedPrimaryCustomer.value = data;
  }
};

const onCloseDialog = (reloadData?: boolean) => {
  selectedMergedCustomers.value = [];
  step.value = actions.list;
  emits("toggle", reloadData);
};

const onClickPreview = () => {
  previousStep.value = actions.preview;
  step.value = actions.preview;
};

const onClickBack = () => {
  step.value = actions.list;
  previousStep.value = undefined;
};

const onClickMerge = () => {
  if (previousStep.value === actions.merge) {
    confirm.require({
      defaultFocus: "",
      message: "顧客は統合されます。よろしいですか？",
      header: "統合します",
      rejectLabel: "キャンセル",
      acceptLabel: "OK",
      acceptClass: "p-button",
      accept: onMerge,
    });
  } else {
    previousStep.value = actions.merge;
    step.value = actions.preview;
  }
};

const onMerge = () => {
  DuplicateCustomerService.mergeData(
    {
      clinic_id: props.clinicId.value,
      primary_customer_id: selectedPrimaryCustomer.value.id,
      duplicate_customer_ids: selectedMergedCustomers.value.map(customer => customer.id),
    },
    () => {
      notifySuccessMsg(toast, "成功");
      onCloseDialog(true);
    },
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
};

const fetchPreviewData = async () => {
  previewLoading.value = true;
  const { data: response } = await DuplicateCustomerService.fetchPreviewData(
    {
      clinic_id: props.clinicId.value,
      primary_customer_id: selectedPrimaryCustomer.value.id,
      merged_customer_ids: selectedMergedCustomers.value.map(customer => customer.id),
    },
    () => undefined,
    () => undefined
  );
  const sortedKeys = Object.keys(PreviewMergedCustomerFieldNames);
  const formattedData = Object.entries(response.value)
    .map(([key, value]) => ({
      type: key,
      value: value,
      label: PreviewMergedCustomerFieldNames[key],
    }))
    .sort((a, b) => sortedKeys.indexOf(a.type) - sortedKeys.indexOf(b.type));
  previewData.value = formattedData;
  previewLoading.value = false;
};

watch(
  () => props.primaryCustomer,
  newCustomer => {
    selectedPrimaryCustomer.value = newCustomer;
    selectedMergedCustomers.value = [];
    step.value = actions.list;
    previousStep.value = undefined;
  }
);
watch(
  () => selectedPrimaryCustomer.value,
  newCustomer => (filteredMergedCustomers.value = props.duplicateCustomers.filter(c => c.id !== newCustomer.id))
);
watch(
  () => step.value,
  newStep => {
    if (newStep === actions.preview) fetchPreviewData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      modal: "",
      appendTo: "self",
      visible: props.visible,
      style: { width: '60vw', height: '75vh' },
      draggable: false,
      class: "mx-5 border-0"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", { class: "flex w-full justify-content-between align-items-center" }, [
          _hoisted_2,
          _createElementVNode("i", {
            class: "pi pi-times pr-2 cursor-pointer",
            onClick: onCloseDialog
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (step.value == actions.list)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-light",
                label: "キャンセル",
                onClick: onCloseDialog
              }))
            : _createCommentVNode("", true),
          (step.value == actions.preview || step.value == actions.merge)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "p-button-light",
                label: "戻る",
                onClick: onClickBack
              }))
            : _createCommentVNode("", true),
          (step.value == actions.list)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                class: "p-button-light",
                label: "プレビュー",
                onClick: onClickPreview,
                disabled: !_unref(validToMerge)
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (step.value == actions.list || previousStep.value == actions.merge)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                label: "統合確認へ",
                onClick: onClickMerge,
                disabled: !_unref(validToMerge)
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (step.value == actions.list)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(CustomerTable, {
                items: __props.duplicateCustomers,
                "selected-customers": selectedPrimaryCustomer.value,
                onDataChange: onTableDataChange
              }, {
                title: _withCtx(() => [
                  _createTextVNode("1, メイン顧客情報")
                ]),
                _: 1
              }, 8, ["items", "selected-customers"]),
              _createVNode(CustomerTable, {
                class: "mt-2",
                "select-multiple": "",
                items: filteredMergedCustomers.value,
                "selected-customers": selectedMergedCustomers.value,
                onDataChange: onTableDataChange
              }, {
                title: _withCtx(() => [
                  _createTextVNode("2, 統合される顧客情報")
                ]),
                _: 1
              }, 8, ["items", "selected-customers"])
            ]))
          : (step.value == actions.preview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Preview, {
                  data: previewData.value,
                  loading: previewLoading.value
                }, null, 8, ["data", "loading"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})